import ReactNative from 'react-native';
import { useEffect, useRef, useState } from 'react';
import { SharedValue, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { useNavigation } from '@react-navigation/native';

export interface UseModalProps {
  animatedStyle: { height: number };
  childRef: React.RefObject<ReactNative.View>;
  modalVisible: boolean;
  dimensions: SharedValue<{ height: number; width: number }>;
  setModalVisible: (visible: boolean) => void;
}

interface UseModalViewParams {
  dimensions?: { height: number; width: number };
}

export const useModalView = (props: UseModalViewParams): { useModalProps: UseModalProps; closeModal: () => void } => {
  const navigation = useNavigation();
  const [modalVisible, setModalVisible] = useState(true);

  const childRef = useRef<ReactNative.View>(null);

  const dimensions = useSharedValue({
    height: 0,
    width: 0
  });

  const animatedStyle = useAnimatedStyle(() => ({
    height: withTiming(dimensions.value.height, { duration: 300 })
  }));

  useEffect(() => {
    if (props.dimensions) {
      dimensions.value = props.dimensions;
    }
  }, [props.dimensions]);

  const closeModal = () => {
    dimensions.value.height = 0;
    dimensions.value.width = 0;
    setTimeout(() => {
      navigation.goBack();
      setModalVisible(false);
    }, 300);
  };

  const useModalProps: UseModalProps = {
    animatedStyle,
    childRef,
    dimensions,
    modalVisible,
    setModalVisible
  };

  return {
    useModalProps,
    closeModal
  };
};
